export class KeepCurrentScroll {
    constructor() {
        let that = this;
        document.addEventListener("DOMContentLoaded", function(event){
            that.init();
        });
    }
    init() {
        const currentUrl = window.location.href;
        if(currentUrl.includes('subscription') && localStorage.scrollPosition && JSON.parse(localStorage.scrollPosition).currentPage == window.location.href.split('?')[0]) {
            history.scrollRestoration = 'manual';
            const ctaNewsletterElem = document.querySelector('.cta-newsletter');
            ctaNewsletterElem.scrollIntoView({block: "center", behavior: "auto"});
            window.setTimeout(() => {
                ctaNewsletterElem.scrollIntoView({block: "center", behavior: "auto"});
            }, 1500)
        } else {
            history.scrollRestoration = 'auto';
        }
        const currentObject = {
            currentScroll: window.scrollY,
            currentPage: window.location.href.split('?')[0]
        }
        localStorage.setItem("scrollPosition", JSON.stringify(currentObject));
        document.addEventListener('scroll', function(e) {
            const currentObject = {
                currentScroll: window.scrollY,
                currentPage: window.location.href.split('?')[0]
            }
            localStorage.setItem("scrollPosition", JSON.stringify(currentObject));
        });
    }
}
